/**
 * Utility to detect URLs in text and convert them to clickable links
 */

import type { ThemePalette } from './themeUtils'

/**
 * URL regex pattern that matches http, https URLs
 */
const URL_REGEX = /(https?:\/\/[^\s<>"']+)/gi

/**
 * Converts plain text containing URLs into React elements with clickable links
 * @param text - The plain text that may contain URLs
 * @param palette - Theme palette for styling links
 * @returns Array of React nodes with URLs converted to anchor tags
 */
export function linkifyText(
    text: string,
    palette: ThemePalette
): React.ReactNode[] {
    if (!text) return []

    const parts = text.split(URL_REGEX)

    return parts.map((part, index) => {
        // Check if this part is a URL
        if (URL_REGEX.test(part)) {
            // Reset regex lastIndex since we're using global flag
            URL_REGEX.lastIndex = 0
            return (
                <a
                    key={index}
                    href={part}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                        color: palette.userBubble,
                        textDecoration: 'underline',
                        cursor: 'pointer',
                        wordBreak: 'break-all',
                    }}
                    onClick={(e) => e.stopPropagation()}
                >
                    {part}
                </a>
            )
        }
        return part
    })
}
